import { useEffect, useState } from "react";

/**
 * Tracks vertical scroll position with `requestAnimationFrame` throttling.
 * Used by the navbar to swap to a blurred / bordered style after 40px.
 */
export function useScrollPosition(): number {
  const [scrollY, setScrollY] = useState<number>(() =>
    typeof window === "undefined" ? 0 : window.scrollY,
  );

  useEffect(() => {
    let frame = 0;
    const onScroll = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        setScrollY(window.scrollY);
        frame = 0;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);

  return scrollY;
}
